var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-headline",class:{ 
    'text-center': _vm.center,
    'page-headline--white': _vm.white,
    'page-headline--title': !_vm.description
  }},[_c('h2',{class:{ 'text-white': _vm.white },domProps:{"textContent":_vm._s(_vm.title)}}),(_vm.description)?_c('p',{staticClass:"lead measure-lead text-black-70",class:{ 'mx-auto': _vm.center },domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }